import { render } from "./PostStats.vue?vue&type=template&id=45ff5e25&scoped=true"
import script from "./PostStats.vue?vue&type=script&lang=js"
export * from "./PostStats.vue?vue&type=script&lang=js"

import "./post-stats.scss?vue&type=style&index=0&id=45ff5e25&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ff5e25"]])

export default __exports__